import React from 'react';
import PropTypes from "prop-types";
import styles from "./ComponentSearchDomainForm.scss";
import Typed from "typed.js";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import Submit from "../../common/primitives/Submit";
import TextBox from "../../common/primitives/TextBox";
import textBoxStyles from "../../common/primitives/TextBox.scss";
import BaseComponent, {AjaxParam} from "../../common/BaseComponent/BaseComponent";
import {ContextTLD} from "../../context/ContextTLDProvider";
import {_validateDomainNameSimple} from "../../common/helpers/HelperValidator";
import {notify} from "../../common/primitives/Notification/Notification";
import ButtonArrow from "../../common/primitives/ButtonArrow";
import {__t} from '../../common/lang/text-resource';

class ComponentSearchDomainForm extends BaseComponent {

	static contextType = ContextTLD;

	static propTypes = {
		isTransparent: PropTypes.bool,
		doNotCalcInputWidth: PropTypes.bool,
		placeholder: PropTypes.string,
		animationPlaceholders: PropTypes.arrayOf(PropTypes.string),
		customGA4Event: PropTypes.func
	};

	static defaultProps = {
		placeholder: 'www.mysupersite.net',
		animationPlaceholders: ["www.mysupersite.com", "www.mysupersite.bg", "www.mysupersite.eu", "www.mysupersite.net"]
	};

	typed = null;

	componentDidMount() {
		document.addEventListener("DOMContentLoaded", this.importTyped);
	}

	componentWillUnmount() {
		document.removeEventListener("DOMContentLoaded", this.importTyped);
	}

	onInputFocus = e => {
		if (e.target.getAttribute('type') === 'submit') {
			return;
		}
		if (this.typed) {
			this.typed.destroy();
		}
		const elements = document.getElementsByClassName(styles.placeholderContainer);
		if (elements.length) {
			elements[0].parentNode.removeChild(elements[0]);
		}
		const input = document.getElementById('domainName');
		input.focus();
		input.placeholder = this.props.placeholder;
	};

	importTyped = () => {
		if (this.props.animationPlaceholders.length > 0) {
			this.typed = new Typed(`.${styles.placeholderContainer} span`, {
				strings: this.props.animationPlaceholders,
				typeSpeed: 70,
				backSpeed: 110,
				backDelay: 800,
				smartBackspace: true,
				showCursor: true,
				autoInsertCss: true
			});
		}
	};

	onSubmitForm = (e) => {
		e.preventDefault();
		let target = e.target;
		let domainNameFull = document.getElementById('domainName').value;

		domainNameFull = domainNameFull.replace('www.', '');
		if (domainNameFull === '') {
			alert(this.messages.EMPTY_DOMAIN_NAME_ERROR);
			return;
		}
		////////////////////////////////////////
		////////////////////////////////////////
		domainNameFull = domainNameFull.toLowerCase().trim();
		const arrDomainData = domainNameFull.split('.');
		let domainName = arrDomainData[0];
		let domainTld = domainNameFull.substr(domainName.length + 1);
		if (domainTld === '') {
			domainTld = 'com';
		}
		////////////////////////////////////////
		////////////////////////////////////////

		if (typeof this.context.validateDomainName === 'function') {
			try {
				this.context.validateDomainName(domainName + '.' + domainTld, false);

			} catch (e) {
				alert(this.messages[e].replace('{%domainName%}', domainNameFull));
				return;
			}

			const eventData = {
				event_category: 'InCart Actions',
				event_label: 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]',
				non_interaction: true
			};
			HelperGoogleAnalytics.TrackEvent('Domain Selector - Query Domain', eventData);
			HelperGoogleAnalytics4.TrackEvent('InCart Actions', 'Domain Selector - Query Domain', 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]');
			/////////////////////////////////////////////////
			/////////////////////////////////////////////////


			target.action = '/web-hosting-order-domain-results.php';
			target.submit();
		} else {

			try {
				_validateDomainNameSimple(domainName + '.' + domainTld);
			} catch (e) {
				alert(this.messages[e].replace('{%domainName%}', domainNameFull));
				return;
			}

			const ajaxParam = new AjaxParam();
			ajaxParam.callbackError = data => {
				const errorMessage = data.componentErrors[0];
				notify.error(this.messages[errorMessage] || errorMessage);
			}

			ajaxParam.callbackSuccess = () => {
				const eventData = {
					event_category: 'InCart Actions',
					event_label: 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]',
					non_interaction: true
				};
				HelperGoogleAnalytics.TrackEvent('Domain Selector - Query Domain', eventData);
				HelperGoogleAnalytics4.TrackEvent('InCart Actions', 'Domain Selector - Query Domain', 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]');

				if (this.props.customGA4Event) {
					this.props.customGA4Event();
				}
				/////////////////////////////////////////////////
				/////////////////////////////////////////////////


				target.action = '/web-hosting-order-domain-results.php';
				target.submit();
			}

			this.rootPage().ajaxCall('ActionValidateDomainName', {domainNameFull: domainName + '.' + domainTld}, ajaxParam);
		}
	};

	render() {

		let inputClasses = [];
		inputClasses.push(textBoxStyles.thicker)
		inputClasses.push(styles.textInput)
		if (this.props.isTransparent) {
			inputClasses.push(textBoxStyles.transparent)
		} else {
			inputClasses.push(textBoxStyles.default)
		}
		if (this.props.doNotCalcInputWidth) {
			inputClasses.push(styles.doNotCalcInputWidth);
		}


		return (
		  <form
			action={''}
			onSubmit={this.onSubmitForm}
			method='get'
			autoComplete={"off"}
			className={`${styles.form} ${this.props.isTransparent === true ? styles.isTransparent : ''}`}
			data-test="search-domain-form">
			  <div
				className={`${styles.inputContainer} ${this.props.doNotCalcInputWidth === true && styles.doNotCalcInputWidth}`}>
				  <Submit ariaLabel={'Търсене на домейн'} value={''} id={'dfgxzi45'}/>
				  <TextBox
					name='domainName'
					type='search'
					id='domainName'
					className={inputClasses.join(" ")}
					onFocus={this.onInputFocus}
					autoComplete={"off"}
				  />
				  <TextBox name={'newmode'} type={'hidden'} value={'1'}/>

				  <div className={styles.placeholderContainer} onClick={this.onInputFocus}>
					  <span/>
				  </div>
			  </div>
			  <div
				className={`${styles.submitButton} ${this.props.doNotCalcInputWidth === true ? styles.doNotCalcInputWidth : ''}`}>
				  <Submit ariaLabel={__t('Търсене на домейн')} value={__t('Потърси домейн')} id={'dfgxzi452'}/>
			  </div>
			  <div data-layout={'hide@md'}>
				  <ButtonArrow bigger={true} type={'submit'}/>
			  </div>
		  </form>
		)
	}
}

export default ComponentSearchDomainForm;
